import React, { useState, useEffect } from 'react';
import './ToursSearch.css';

import { destinationOptions, durationOptions, tourTypeOptions, activityOptions, extractSearchParams, handleSelectChange } from '../../utils/TourUtils';
import { showErrorToast } from '../../components';

import Select from 'react-select';
import { useLocation } from 'react-router-dom';


const TourSearch = ({ onFormSubmit }) => {
  const location = useLocation();
  
  // State variables for form fields
  const [destination, setDestination] = useState('');
  const [departureDate, setDepartureDate] = useState('');
  const [duration, setDuration] = useState('');
  const [tourType, setTourType] = useState('');
  const [activity, setActivity] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');

  // Extract query parameters from the URL
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    const params = extractSearchParams(queryParams);
    setDestination(params.destination);
    setDepartureDate(params.departureDate);
    setDuration(params.duration);
    setTourType(params.tourType);
    setActivity(params.activity);
    setMinPrice(params.minPrice);
    setMaxPrice(params.maxPrice);
  }, [location.search]);

  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Validate price range
    if (minPrice && maxPrice && Number(minPrice) > Number(maxPrice)) {
      showErrorToast("Max price must exceed min price");
      return;
    }

    onFormSubmit({
      destination,
      departureDate,
      duration,
      tourType,
      activity,
      minPrice,
      maxPrice
    });

  };

  // Add today's date as min for departure date
  const today = new Date().toISOString().split('T')[0];

  return (
    <section className="tourSearch">
      <form className="tour-search" onSubmit={handleFormSubmit}>
        
        <Select
          options={destinationOptions}
          value={destinationOptions.find(opt => opt.value === destination)}
          onChange={handleSelectChange(setDestination)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Destination"
        />

        <div className="box">
          <input
            type="date"
            value={departureDate}
            min={today}  // Prevent selecting past dates
            onChange={(e) => setDepartureDate(e.target.value)}
            className="input-field"
            placeholder="Departure Date"
          />
        </div>

        <Select
          options={durationOptions}
          value={durationOptions.find(opt => opt.value === duration)}
          onChange={handleSelectChange(setDuration)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Duration"
        />

        <Select
          options={tourTypeOptions}
          value={tourTypeOptions.find(opt => opt.value === tourType)}
          onChange={handleSelectChange(setTourType)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Tour Type"
        />

        <Select
          options={activityOptions}
          value={activityOptions.find(opt => opt.value === activity)}
          onChange={handleSelectChange(setActivity)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Activity"
        />

        <div className="box">
          <input
            type="number"
            placeholder="Min Price"
            value={minPrice}
            onChange={(e) => setMinPrice(e.target.value)}
            className="input-field"
            min="0"
          />
        </div>

        <div className="box">
          <input
            type="number"
            placeholder="Max Price"
            value={maxPrice}
            onChange={(e) => setMaxPrice(e.target.value)}
            className="input-field"
            min="0"
          />
        </div>

        <div className="box">
          <button type="submit" className="btn">
            Search Tours
          </button>
        </div>
      </form>
    </section>
  );
};

export default TourSearch;